import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/default.svg'
import _imports_1 from '@/assets/advance_upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-3a26ac69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advance" }
const _hoisted_2 = { class: "mod_wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mod_c" }
const _hoisted_5 = {
  key: 0,
  class: "mod_c_title"
}
const _hoisted_6 = { class: "mod_c_tbody" }
const _hoisted_7 = { class: "advance_box" }
const _hoisted_8 = { class: "advance_preview" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"width":"300px"}
}, null, -1))
const _hoisted_10 = { class: "preview_cv" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "preview_mark"
}
const _hoisted_13 = {
  key: 0,
  class: "preview_square"
}
const _hoisted_14 = {
  class: "mark_box",
  style: {}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "mark_box"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "preview_img"
}
const _hoisted_19 = {
  key: 1,
  class: "preview_watermark"
}
const _hoisted_20 = {
  key: 0,
  class: "preview_square"
}
const _hoisted_21 = { class: "mark_box" }
const _hoisted_22 = {
  key: 1,
  class: "mark_box"
}
const _hoisted_23 = { class: "advance_content" }
const _hoisted_24 = { class: "water_mark" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "water_mark_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 水印类型: ")
], -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "water_mark_phone" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name topping" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "water_mark_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 水印图片: ")
], -1))
const _hoisted_29 = { class: "img_up" }
const _hoisted_30 = {
  key: 0,
  class: "before_upload"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload" }, "点击选择图片", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload_text" }, [
  /*#__PURE__*/_createTextVNode(" 或把图片拖到这里，上传最多可选1个图片；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持单文件最大2M，建议透明背景。 ")
], -1))
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "hover_box"
}
const _hoisted_36 = { class: "after_scroll" }
const _hoisted_37 = { class: "after_upload" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "upload_footer" }
const _hoisted_40 = {
  key: 0,
  class: "img_box"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_hover" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "water_mark" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "不透明度:", -1))
const _hoisted_45 = {
  key: 0,
  class: "water_mark"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "图片边距:", -1))
const _hoisted_47 = { class: "water_mark" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "图片尺寸:", -1))
const _hoisted_49 = { class: "water_mark_input" }
const _hoisted_50 = {
  key: 1,
  class: "text_watermark"
}
const _hoisted_51 = { class: "water_mark" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "water_mark_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 水印文本: ")
], -1))
const _hoisted_53 = { class: "water_position_input" }
const _hoisted_54 = {
  key: 0,
  class: "water_mark"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "water_mark_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 文本内容: ")
], -1))
const _hoisted_56 = { class: "input_area" }
const _hoisted_57 = { class: "text_number" }
const _hoisted_58 = {
  key: 1,
  class: "water_mark"
}
const _hoisted_59 = { class: "advance_tip" }
const _hoisted_60 = { class: "water_mark" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "文字大小:", -1))
const _hoisted_62 = { class: "text_size" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_px" }, "px", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "文字颜色:", -1))
const _hoisted_65 = { class: "theme_color" }
const _hoisted_66 = { class: "theme_common" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "channer_colorselector" }
const _hoisted_69 = { class: "theme_title" }
const _hoisted_70 = { class: "water_mark" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "不透明度:", -1))
const _hoisted_72 = { class: "water_mark_location" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "water_mark_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 水印位置: ")
], -1))
const _hoisted_74 = { class: "water_position_input" }
const _hoisted_75 = {
  key: 0,
  class: "water_select_option"
}
const _hoisted_76 = {
  key: 2,
  class: "water_mark"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name" }, "上边距:", -1))
const _hoisted_78 = { class: "vertica_margin" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_px" }, "%", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "water_mark_name certical" }, "左边距:", -1))
const _hoisted_81 = { class: "vertica_margin" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_px" }, "%", -1))
const _hoisted_83 = { class: "advance_btn" }

import Crumb from '@/components/Crumb.vue';
import { useRoute } from 'vue-router';
import { Switch, Radio, Col, Slider, InputNumber, Progress, Spin, message } from 'ant-design-vue';
import { ref, computed } from 'vue';
import { ElUpload } from 'element-plus';
import { getToken } from '@/plugins/cookie';
import { DownOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import { expressDom } from '../components/type';
import { ElColorPicker } from 'element-plus';
import { useStore } from 'vuex';
import http from '@/api/waterMark';
import domtoimage from 'dom-to-image';
import axios from 'axios';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
  raw?: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AntiRecordingScreen',
  setup(__props) {

const store = useStore();
const cvUrl = computed(() => store.state.home.customData.video_url);
const userData = computed(() => store.state.user.userInfo);

const route = useRoute();
const aSwitch = Switch;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aCol = Col;
const aSlider = Slider;
const aInputNumber = InputNumber;
const aProgress = Progress;
const aSpin = Spin;

const studioId = route.params.studioId;

// 头部开关
const status = ref(0);
const token = getToken();
// 水印类型
const water_type = ref('0');
// // 不透明度
// 图片尺寸
const picture_small = ref<number>(10);
const picture_big = ref<number>(10);
// 图片尺寸锁定状态 0是开，1是关
const locks = ref(true);
const robotLock = () => {
  locks.value = !locks.value;
};

// 垂直边距
const verticalInput = ref(0);
// 水平边距
const certicalInput = ref(0);
// 上传图片
const advanceUpload = ref(false);
const aSpins = ref(false);
const aMantle = ref(false);
const showProgress = ref(false);
const aButtons = ref(false);
// 水印位置
const Popup = ref<expressDom[]>([]);
// radioPops
const radioValue = ref<number>(6);

// S 动态交互
const waterRadio = (id: number) => {
  switch (id) {
    case 6:
      verticalInput.value = certicalInput.value = 0;
      break;
    case 7:
      verticalInput.value = 0;
      certicalInput.value = 50;
      break;
    case 8:
      verticalInput.value = 0;
      certicalInput.value = 100;
      break;
    case 9:
      verticalInput.value = 50;
      certicalInput.value = 0;
      break;
    case 10:
      verticalInput.value = certicalInput.value = 50;
      break;
    case 11:
      verticalInput.value = 50;
      certicalInput.value = 100;
      break;
    case 12:
      verticalInput.value = 100;
      certicalInput.value = 0;
      break;
    case 13:
      verticalInput.value = 100;
      certicalInput.value = 50;
      break;
    case 14:
      verticalInput.value = certicalInput.value = 100;
      break;
  }
};

const getWaterRadio = (x: number, y: number) => {
  if (x === 0 && y === 0) {
    radioValue.value = 6;
  } else if (x === 0 && y === 50) {
    radioValue.value = 7;
  } else if (x === 0 && y === 100) {
    radioValue.value = 8;
  } else if (x === 50 && y === 0) {
    radioValue.value = 9;
  } else if (x === 50 && y === 50) {
    radioValue.value = 10;
  } else if (x === 50 && y === 100) {
    radioValue.value = 11;
  } else if (x === 100 && y === 0) {
    radioValue.value = 12;
  } else if (x === 100 && y === 50) {
    radioValue.value = 13;
  } else if (x === 100 && y === 100) {
    radioValue.value = 14;
  } else {
    radioValue.value = 6;
  }
};

const changeSeat = () => {
  verticalInput.value = 0;
  certicalInput.value = 0;
  radioValue.value = 6;
};

// 计算自定义位置
const poslH = computed(() => verticalInput.value + '%');
const poslW = computed(() => certicalInput.value + '%');
const poslTop = computed(() => Number(picture_big.value * (Number(verticalInput.value) / 100)) + 'px');
const poslLeft = computed(() => Number(picture_small.value * (Number(certicalInput.value) / 100)) + 'px');
const textRef = ref();
const poslTextTop = computed(
  () => Number((textRef.value ? textRef.value.clientHeight : 0) * (Number(verticalInput.value) / 100)) + 'px'
);
const poslTextLeft = computed(
  () => Number((textRef.value ? textRef.value.clientWidth : 0) * (Number(certicalInput.value) / 100)) + 'px'
);

// 计算文字满屏长度
const textW = computed(() => (waterMarkText.value ? textContent.value : userData.value.name));
const wLength = computed(() => (textW.value.length ? 280 / (textW.value.length * textSize.value) : 0));
const hLength = computed(() => 157 / Number(textSize.value * 1.5715));
const tLength = computed(() => Math.ceil(wLength.value) * Math.ceil(hLength.value));

const backGauge = ref(); //铺满时图片边距 单位是对于图片尺寸的百分比

// 满屏边距 动态样式
const marW = computed(() => (waterMarkLocation.value === 5 ? verticalInput.value + 'px' : imgHHide.value));
const marH = computed(() => (waterMarkLocation.value === 5 ? certicalInput.value + 'px' : imgWHide.value));

const imgW = computed(() => picture_small.value + 'px');
const imgH = computed(() => picture_big.value + 'px');
const opacity = computed(() => alpha.value + '%');
const fontSize = computed(() => textSize.value + 'px');
const color = computed(() => textColor.value);
const imgWHide = computed(() => picture_small.value * (backGauge.value / 100) + 'px');
const imgHHide = computed(() => picture_big.value * (backGauge.value / 100) + 'px');
// 计算图片满屏长度
const wImgLength = computed(() => 280 / (picture_small.value + Number(certicalInput.value)));
const hImgLength = computed(() => 157 / (picture_big.value + Number(verticalInput.value)));
const tImgLength = computed(() => Math.ceil(wImgLength.value) * Math.ceil(hImgLength.value));

// E 动态交互
// 水印文本
const waterMarkText = ref(1);
const mark_text = ref([
  {
    label: '用户昵称',
    value: 0,
  },
  {
    label: '自定义文本',
    value: 1,
  },
]);
// 文本内容
const textContent = ref('');
// 文字大小
const textSize = ref(12);
// 水印位置
const waterMarkLocation = ref();
const mark_location = ref<expressDom[]>([]);

// 不透明度
const alpha = ref<number>(2);

// 颜色选择器显示/隐藏
const colorList = ref(['#00CCb0', '#1890FF', '#FF4D4F']);
const textColor = ref(colorList.value[0]);
const selectcolor = (colors: any) => {
  textColor.value = colors;
};

// 上传图片事件
let obj = ref({
  channelpicture: '',
  chan: 0,
  percentage: 0,
  fileSize: 0,
});
const fileList = ref<any>([]);
const loading = ref<boolean>(false);
const beforeUpload = (file: any) => {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('上传图片大小必须小于 2MB!');
    return isLt2M;
  }
  fileList.value = [];
  advanceUpload.value = true;
  aMantle.value = true;
  obj.value.fileSize = file.size;
  fileList.value = [...fileList.value, file];
  obj.value.channelpicture = window.URL.createObjectURL(fileList.value[0]);
  aButtons.value = false;

  let reader = new FileReader();
  reader.onload = function () {
    const img = document.createElement('img');
    img.src = window.URL.createObjectURL(fileList.value[0]);
    img.onload = function () {
      if (img.width < img.height) {
        const num = img.width / img.height;
        picture_big.value = img.height >= 500 ? 500 : img.height;
        picture_small.value = Math.floor(picture_big.value * num);
      } else {
        const num = img.height / img.width;
        picture_small.value = img.width >= 500 ? 500 : img.width;
        picture_big.value = Math.floor(picture_small.value * num);
      }
      locks.value = true;
    };
  };
  reader.readAsDataURL(file);

  return false;
};

const handleAvatarSuccess = (res: any, file: any) => {
  advanceUpload.value = false;
  aButtons.value = true;
  obj.value.channelpicture = URL.createObjectURL(file.raw);
};

const closeFork = () => {
  advanceUpload.value = false;
  aSpins.value = false;
  aButtons.value = false;
  showProgress.value = false;
  aMantle.value = false;
  obj.value.channelpicture = '';
  obj.value.chan = 0;
};

const startUpload = () => {
  aSpins.value = true;
  showProgress.value = true;
  const formData = new FormData();
  obj.value.percentage = 0;
  formData.append('images', fileList.value[0] as any);
  http
    .upImages(formData)
    .then((res) => {
      if (res.data.code == 200) {
        obj.value.percentage = 100;
        advanceUpload.value = true;
        aButtons.value = true;
        aSpins.value = false;
        showProgress.value = false;
        aMantle.value = false;
        fileList.value = [];
        const resData = res.data.data;
        obj.value.channelpicture = resData.url;
        obj.value.chan = resData.id;
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res: any) => {
      aSpins.value = false;
      showProgress.value = false;
      message.destroy();
      message.error(res.data.error);
    });
};
const uploadRef = ref();
const changeUpload = () => {
  aSpins.value = false;
  showProgress.value = false;
};
// 取消按钮
const cancel = () => {
  status.value = 0;
  waterMarkText.value = 0;
  textContent.value = '';
  textSize.value = 12;
  textColor.value = colorList.value[0];
  alpha.value = 2;
  waterMarkLocation.value = 1;
  picture_big.value = 1;
  picture_small.value = 1;
  verticalInput.value = 0;
  certicalInput.value = 0;
};

// 获取列表
const watermarkInfo = () => {
  http
    .getWatermarkInfo({ params: { studio_id: studioId } })
    .then((res) => {
      if (res.data.code == 200) {
        const target = res.data.data;
        status.value = target.status;
        waterMarkText.value = target.text_type;
        textContent.value = target.text_content || '';
        textSize.value = target.font_size;
        textColor.value = target.text_color;
        alpha.value = target.opacity;
        waterMarkLocation.value = target.location_id;
        picture_big.value = target.image_height > 10 ? target.image_height : 10;
        picture_small.value = target.image_width > 10 ? target.image_width : 10;
        verticalInput.value = target.vertical_margin;
        certicalInput.value = target.horizontal_margin;
        obj.value.chan = target.back_watermark_image_id;
        obj.value.channelpicture = target.back_watermark_image_url;
        advanceUpload.value = obj.value.channelpicture ? true : false;
        aButtons.value = obj.value.channelpicture ? true : false;
        water_type.value = target.watermark_type.toString(); //水印类型
        backGauge.value = target.back_gauge;
        waterLocation();
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
watermarkInfo();
//   获取水印位置列表
const locationList = () => {
  let data = {
    type: 0, //下拉中的列表中的数据
    studio_id: studioId,
  };
  http
    .getLocationList({ params: data })
    .then((res) => {
      if (res.data.code == 200) {
        let arr = res.data.data;
        mark_location.value = arr;
      }
    })
    .catch((res: any) => {
      message.destroy();
      message.error(res.data.error);
    });
};
locationList();
const waterLocation = () => {
  let data = {
    type: 1, //自定义位置
    studio_id: studioId,
  };
  http
    .getLocationList({ params: data })
    .then((res) => {
      if (res.data.code == 200) {
        let degree = res.data.data;
        Popup.value = degree;
        if (waterMarkLocation.value === 5) {
          getWaterRadio(verticalInput.value, certicalInput.value);
        }
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

const imgRef = ref();
const imgName = ref();
const imgDataUrl = ref();
//将base64转换为file
const dataURLtoBlob = (dataurl: string) => {
  const arr: any = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

// 设置水印
const liveData = ref();
// 保存
const saveChange = (type?: string) => {
  if (type === '1') imgDataUrl.value = obj.value.chan;
  let data = {
    studio_id: studioId,
    status: status.value,
    watermark_type: water_type.value,
    watermark_image_id: imgDataUrl.value,
    back_watermark_image_id: obj.value.chan,
    text_type: waterMarkText.value,
    text_content: textContent.value,
    font_size: textSize.value,
    text_color: textColor.value,
    opacity: alpha.value,
    location_id: waterMarkLocation.value,
    image_height: picture_big.value,
    image_width: picture_small.value,
    vertical_margin: verticalInput.value,
    horizontal_margin: certicalInput.value,
    back_gauge: backGauge.value,
  };
  http
    .getSetWatermark(data)
    .then((res: any) => {
      liveData.value = res.data.data;
      watermarkInfo();
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
      status.value = Number(!status.value);
    });
};

const style = computed(() => {
  return {
    width: imgW.value,
    height: imgH.value,
    opacity: opacity.value,
    marginTop: imgHHide.value,
    marginBottom: imgHHide.value,
    marginLeft: imgWHide.value,
    marginRight: imgWHide.value,
  };
});
function dataURLtoFile(dataurl: any, filename: string) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const SetWatermark = () => {
  if (waterMarkLocation.value !== 5 && water_type.value === '1') {
    domtoimage
      .toPng(imgRef.value, { bgcolor: 'transparent' })
      .then((dataUrl) => {
        let blobInfo = dataURLtoBlob(dataUrl);
        for (let i = 1; i <= 6; i++) {
          imgName.value += Math.floor(Math.random() * 10);
        }
        const formData = new FormData();
        formData.append('images', blobInfo, imgName.value);
        formData.append('token', token as any);
        axios
          .post('/api/v1/common/upload_images', formData)
          .then((res) => {
            if (res.data.code == 200) {
              imgDataUrl.value = res.data.data.id;
              saveChange();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    imgDataUrl.value = obj.value.chan;
    saveChange();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "imgRef",
        ref: imgRef,
        class: _normalizeClass([`mark_img_tra${waterMarkLocation.value}`, "to_image"])
      }, [
        _createElementVNode("img", {
          src: _unref(obj).channelpicture,
          alt: "",
          class: "preview_square_img",
          style: _normalizeStyle(_unref(style))
        }, null, 12, _hoisted_3)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(route).meta.hidden)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
              _createVNode(_unref(aSwitch), {
                class: "btns_txt",
                checked: status.value,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
                "checked-value": 1,
                "un-checked-value": 0,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (saveChange('1')))
              }, null, 8, ["checked"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _unref(cvUrl),
                  style: {"width":"100%"}
                }, null, 8, _hoisted_11)
              ]),
              (water_type.value === '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_unref(obj).channelpicture && waterMarkLocation.value < 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tImgLength), (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(["mark_img_mar", `mark_img_tra${waterMarkLocation.value}`])
                              }, [
                                _createElementVNode("img", {
                                  src: _unref(obj).channelpicture,
                                  alt: "",
                                  class: "preview_square_img",
                                  style: _normalizeStyle({
                          width: _unref(imgW),
                          height: _unref(imgH),
                          opacity: _unref(opacity),
                          marginTop: _unref(marW),
                          marginBottom: _unref(marW),
                          marginLeft: _unref(marH),
                          marginRight: _unref(marH),
                        })
                                }, null, 12, _hoisted_15)
                              ], 2))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(obj).channelpicture && waterMarkLocation.value === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: _unref(obj).channelpicture,
                            class: "custom_seat preview_square_img",
                            style: _normalizeStyle({
                      width: _unref(imgW),
                      height: _unref(imgH),
                      opacity: _unref(opacity),
                      top: `calc(${_unref(poslH)} - ${_unref(poslTop)})`,
                      left: `calc(${_unref(poslW)} - ${_unref(poslLeft)})`,
                    })
                          }, null, 12, _hoisted_17)
                        ]))
                      : _createCommentVNode("", true),
                    (!_unref(obj).channelpicture)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_svg_icon, {
                            class: "icon",
                            "icon-class": "advance_preview"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (water_type.value === '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (waterMarkLocation.value < 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tLength), (item, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: _normalizeClass(`mark_img_tra${waterMarkLocation.value === 4 ? '5' : waterMarkLocation.value}`),
                                style: _normalizeStyle({
                        fontSize: _unref(fontSize),
                        color: _unref(color),
                        opacity: _unref(opacity),
                        marginTop: _unref(marW),
                        marginBottom: _unref(marW),
                        marginLeft: _unref(marH),
                        marginRight: _unref(marH),
                      })
                              }, _toDisplayString(waterMarkText.value ? textContent.value : _unref(userData).name), 7))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (waterMarkLocation.value === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", {
                            ref_key: "textRef",
                            ref: textRef,
                            class: "custom_seat",
                            style: _normalizeStyle({
                      lineHeight: _unref(fontSize),
                      fontSize: _unref(fontSize),
                      color: _unref(color),
                      opacity: _unref(opacity),
                      top: `calc(${_unref(poslH)} - ${_unref(poslTextTop)})`,
                      left: `calc(${_unref(poslW)} - ${_unref(poslTextLeft)})`,
                    })
                          }, _toDisplayString(waterMarkText.value ? textContent.value : _unref(userData).name), 5)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_unref(aRadioGroup), {
                  name: "radioGroup",
                  value: water_type.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((water_type).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aRadio), { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("图片水印")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(aRadio), { value: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("文字水印")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              (water_type.value === '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_unref(ElUpload), {
                          class: "avatar_upload",
                          ref_key: "uploadRef",
                          ref: uploadRef,
                          name: "images",
                          drag: "",
                          multiple: true,
                          headers: { token: _unref(token) },
                          action: "/api/v1/common/upload_images",
                          accept: ".jpg,.jpeg,.png,",
                          "show-file-list": false,
                          loading: loading.value,
                          "file-list": fileList.value,
                          "before-upload": beforeUpload,
                          "on-success": handleAvatarSuccess,
                          trigger: ""
                        }, {
                          default: _withCtx(() => [
                            (!advanceUpload.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_34))
                              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("img", {
                                        src: _unref(obj).channelpicture,
                                        alt: ""
                                      }, null, 8, _hoisted_38)
                                    ])
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_39, [
                              (aSpins.value)
                                ? (_openBlock(), _createBlock(_unref(aProgress), {
                                    key: 0,
                                    percent: _unref(obj).percentage,
                                    status: "active",
                                    format: (percent) => `上传中：${percent}%`,
                                    size: "small",
                                    class: "progress"
                                  }, null, 8, ["percent", "format"]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                  }, " 共" + _toDisplayString(_unref(obj).channelpicture ? '1' : '0') + "个(" + _toDisplayString((_unref(obj).fileSize / 1024 / 1024).toFixed(2)) + "OB),已上传" + _toDisplayString(_unref(obj).channelpicture ? '1' : '0') + "个。 ", 1))
                            ]),
                            (aButtons.value)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 2,
                                  class: "change_btn",
                                  onClick: changeUpload
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("上传更换")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["headers", "loading", "file-list"]),
                        (aMantle.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                          : _createCommentVNode("", true),
                        (advanceUpload.value)
                          ? (_openBlock(), _createBlock(_component_svg_icon, {
                              key: 1,
                              "icon-class": "fork",
                              class: "fork",
                              onClick: closeFork
                            }))
                          : _createCommentVNode("", true),
                        (aSpins.value)
                          ? (_openBlock(), _createBlock(_unref(aSpin), {
                              key: 2,
                              class: "after_loading"
                            }))
                          : _createCommentVNode("", true),
                        (!aButtons.value)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 3,
                              class: _normalizeClass(["start_btn", { star: advanceUpload.value ? true : false }]),
                              onClick: startUpload
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("开始上传")
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(aCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aSlider), {
                                value: alpha.value,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((alpha).value = $event)),
                                min: 0,
                                max: 100,
                                class: "input_slider"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(aCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aInputNumber), {
                                value: alpha.value,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((alpha).value = $event)),
                                min: 0,
                                max: 100,
                                formatter: (value) => `${value}%`,
                                parser: (value) => value.replace('%', ''),
                                class: "input_number"
                              }, null, 8, ["value", "formatter", "parser"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    (waterMarkLocation.value !== 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aCol), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(aSlider), {
                                    value: backGauge.value,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((backGauge).value = $event)),
                                    min: 1,
                                    max: 100,
                                    class: "input_slider"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(aCol), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(aInputNumber), {
                                    value: backGauge.value,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((backGauge).value = $event)),
                                    min: 0,
                                    max: 100,
                                    formatter: (value) => `${value}%`,
                                    parser: (value) => value.replace('%', ''),
                                    class: "input_number"
                                  }, null, 8, ["value", "formatter", "parser"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_unref(aInputNumber), {
                          min: 10,
                          max: 500,
                          value: picture_small.value,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((picture_small).value = $event)),
                          disabled: locks.value
                        }, null, 8, ["value", "disabled"]),
                        _createVNode(_component_svg_icon, {
                          value: locks.value,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((locks).value = $event)),
                          "icon-class": locks.value ? 'control_locks' : 'control_lock',
                          onClick: robotLock,
                          class: "water_market_lock"
                        }, null, 8, ["value", "icon-class"]),
                        _createVNode(_unref(aInputNumber), {
                          min: 10,
                          max: 500,
                          value: picture_big.value,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((picture_big).value = $event)),
                          disabled: locks.value
                        }, null, 8, ["value", "disabled"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (water_type.value === '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_a_select, {
                          value: waterMarkText.value,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((waterMarkText).value = $event)),
                          class: "water_position",
                          options: mark_text.value,
                          placeholder: "用户ID"
                        }, {
                          suffixIcon: _withCtx(() => [
                            _createVNode(_unref(DownOutlined), { class: "down_qutline" })
                          ]),
                          _: 1
                        }, 8, ["value", "options"])
                      ])
                    ]),
                    (waterMarkText.value === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_a_input, {
                              value: textContent.value,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((textContent).value = $event)),
                              class: "area_tex",
                              "show-count": "",
                              maxlength: 8,
                              placeholder: "请输入标题"
                            }, {
                              suffix: _withCtx(() => [
                                _createElementVNode("div", _hoisted_57, _toDisplayString(textContent.value.length) + "/8", 1)
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (waterMarkText.value === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_unref(InfoCircleOutlined), { class: "info_circle" }),
                            _createTextVNode(" 选择用户ID，播放器文字水印将显示用户昵称 ")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_a_input, {
                          value: textSize.value,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((textSize).value = $event)),
                          class: "vertical_input"
                        }, null, 8, ["value"]),
                        _hoisted_63
                      ]),
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "theme_common_color",
                              key: item,
                              onClick: ($event: any) => (selectcolor(item)),
                              style: _normalizeStyle({ background: item })
                            }, null, 12, _hoisted_67))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(textColor.value), 1),
                        _createVNode(_unref(ElColorPicker), {
                          modelValue: textColor.value,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((textColor).value = $event)),
                          predefine: colorList.value,
                          size: "mini"
                        }, null, 8, ["modelValue", "predefine"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(aCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aSlider), {
                                value: alpha.value,
                                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((alpha).value = $event)),
                                min: 0,
                                max: 100,
                                class: "input_slider"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(aCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(aInputNumber), {
                                value: alpha.value,
                                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((alpha).value = $event)),
                                min: 0,
                                max: 100,
                                formatter: (value) => `${value}%`,
                                parser: (value) => value.replace('%', ''),
                                class: "input_number"
                              }, null, 8, ["value", "formatter", "parser"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_a_select, {
                    value: waterMarkLocation.value,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((waterMarkLocation).value = $event)),
                    class: "water_position",
                    onChange: changeSeat,
                    placeholder: "左倾斜"
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_unref(DownOutlined), { class: "down_qutline" })
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mark_location.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          value: item.id,
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.location_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_unref(aRadioGroup), {
                    value: radioValue.value,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((radioValue).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (waterMarkLocation.value === 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Popup.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(["select_option_direction", { active: radioValue.value == item.id }])
                              }, [
                                _createVNode(_unref(aRadio), {
                                  value: item.id,
                                  onClick: ($event: any) => (waterRadio(item.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.location_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"])
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              (waterMarkLocation.value === 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _hoisted_77,
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_a_input, {
                        value: verticalInput.value,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((verticalInput).value = $event)),
                        class: "vertical_input"
                      }, null, 8, ["value"]),
                      _hoisted_79
                    ]),
                    _hoisted_80,
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_a_input, {
                        value: certicalInput.value,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((certicalInput).value = $event)),
                        class: "vertical_input"
                      }, null, 8, ["value"]),
                      _hoisted_82
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createVNode(_component_a_button, { onClick: cancel }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "button_keep",
              onClick: SetWatermark
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})